import { loadStripe } from '@stripe/stripe-js/pure';

import type { Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Lazily loads Stripe.js, once per page.
 *
 * `loadStripe` injects the `js.stripe.com/v3` script the moment it's called, so
 * calling it at module scope pulled Stripe.js onto every page that happened to
 * pull this module into its chunk. Memoising behind a getter means the script
 * only lands when something actually renders Stripe UI, and repeat callers
 * share the same promise (so `<Elements>` never sees a changing identity).
 */
export const getStripe = (): Promise<Stripe | null> => {
  stripePromise ??= loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY ?? '');

  return stripePromise;
};
